<template lang="pug">
  .cart-apply-promo-form
    form.apply-promo-form(v-if="formOpen" @submit.prevent="applyPromo")
      mr-input.promo-input(label="PROMO CODE" v-model="promoCode" :focus-on-mount="true" required data-mr-ass="promo-input")
      button.mr-btn(type="submit" data-mr-ass="promo-apply") Apply
      p.error.xs-f-small.max-at-tweak(v-if="errorMessage" role="alert") {{errorMessage}}
    
    .open-apply-promo-form.text-center(v-else)
      button.btn-reset.semi-bold.xs-f-small.max-at-tweak(@click="openApplyPromoForm" data-mr-ass="promo-add") Apply promo code or gift card
  
</template>

<script>
  import { mapActions } from 'vuex';

  import mrInput from '../../../mrInput';

  export default {
    name: "CartApplyPromoForm",

    components: {
      mrInput
    },

    data() {
      return {
        formOpen: false,
        promoCode: null,
        errorMessage: null
      }
    },

    methods: {
      ...mapActions('cart', ['applyCoupon']),

      openApplyPromoForm() {
        this.formOpen = true;
        this.promoCode = '';
        this.errorMessage = '';
      },

      applyPromo() {
        this.applyCoupon({
          cartType: 'active',
          code: this.promoCode
        }).then(() => {
          this.formOpen = false;
          this.promoCode = '';
          this.errorMessage = '';
        }).catch((err) => {
          if (err.message) {
            this.errorMessage = err.message;
          }
        });
      }
    }
   }
</script>

<style lang="stylus">
  .cart-apply-promo-form
    margin-bottom 1.5em
    
    .open-apply-promo-form
      border 1px solid color-fog-light
      border-right none
      border-left none
      padding 1em 0
      
    .apply-promo-form
      .mr-btn
      .promo-input
        display inline-block
        vertical-align top
        
      .promo-input
        display inline-block
        width 65%
        
        input
          border-right none
          border-top-right-radius 0
          border-bottom-right-radius 0
          
      .mr-btn
        display inline-block
        width 35%
        height 44px
        line-height 44px
        padding 0
        margin 0.55em 0
      
</style>
